
const UserPoolData = {
    userPoolId : "ap-southeast-2_fUqPqtgja",
    clientId:"ss6tu1l9mqcp2mse2t2gqhlja",
    region:"ap-southeast-2"
}

export default UserPoolData;
